// Pure transitions of the list of photos of one series (server photos, uploads in progress, failed uploads).
// An item is { id?, localId?, kind?, thumbUrl?, url?, status: 'ready' | 'uploading' | 'failed', errorKey?, file? }.

export const fromServer = (photos) => (photos || []).map((photo) => ({ ...photo, status: 'ready' }));

export const pendingEntries = (files, nextId) => files.map((file) => ({ localId: nextId(), status: 'uploading', file }));

export const patchItem = (items, localId, patch) => items.map((item) => (item.localId === localId ? { ...item, ...patch } : item));

// The local item becomes the photos stored by the server (an upload answers with the created photos).
export function replaceLocal(items, localId, photos, kind) {
  const created = (photos || []).map((photo) => ({ id: photo.id, kind: photo.kind || kind, thumbUrl: photo.thumbUrl, url: photo.url, status: 'ready' }));
  const index = items.findIndex((item) => item.localId === localId);
  if (index < 0) return [...items, ...created];
  return [...items.slice(0, index), ...created, ...items.slice(index + 1)];
}

export const removeServerPhoto = (items, id) => items.filter((item) => item.id !== id);
export const removeLocalItem = (items, localId) => items.filter((item) => item.localId !== localId);

// Failed uploads do not take a slot; uploads in progress do.
export const usedSlots = (items) => items.filter((item) => item.status !== 'failed').length;
export const readyPhotos = (items) => items.filter((item) => item.status === 'ready');
export const isBusy = (items) => items.some((item) => item.status === 'uploading');
